import Credentials from "@/components/Credentials";
import Founders from "@/components/Founders";
import { Reveal } from "@/components/primitives";

export default function AboutPage() {
  return (
    <main className="bg-paper pt-20" data-testid="about-page">
      <section className="px-6 pb-24 pt-8 lg:px-12 lg:pb-32 lg:pt-16" data-testid="about-vision-mission">
        <div className="mx-auto grid max-w-[1440px] gap-16 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-ink/50">
                <span className="text-maroon">A</span> · About Us · Our Vision
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2
                className="mt-8 font-serif text-3xl leading-[1.2] text-ink sm:text-4xl lg:text-[2.9rem]"
                data-testid="about-vision"
              >
                Our vision is simple; a future where every space we have touched stands proof that design and
                engineering, built on trust and excellence, can create something{" "}
                <em className="italic text-maroon">extraordinary</em>.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:pt-24">
            <Reveal delay={0.2}>
              <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-maroon">Our Mission</p>
              <p
                className="mt-6 border-l-2 border-maroon pl-6 text-lg leading-relaxed text-ink/80 lg:text-xl"
                data-testid="about-mission"
              >
                To make the process of building your space as confident as the result, through honest
                communication, integrated expertise, and a partnership that lasts beyond a project.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <p className="mt-12 text-[11px] font-medium uppercase tracking-[0.3em] text-maroon">Why we started</p>
              <p className="mt-6 text-base leading-relaxed text-ink/80" data-testid="about-why">
                We built this company after working together and successfully completing the HDFC Bank R Square
                project as ARA Designs and Turnkey Engineers. Delivering it as one team showed us what was
                possible; as ARA Turnkey, architecture and engineering come together as founding principals
                instead of being a sub contract. Each founder brings unique skills, and brought together they
                create synergy and new-age thinking in an industry mainly captured by old players. Our lean
                structure and a world-class vendor network, built and developed over the years, allow us to
                choose the best for every project.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <Credentials />
      <Founders />

      <section className="border-t border-ink/15 bg-paper px-6 py-20 lg:px-12 lg:py-28" data-testid="about-location">
        <div className="mx-auto grid max-w-[1440px] gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-ink/50">
                <span className="text-maroon">@</span> · Visit us
              </p>
              <h2 className="mt-6 font-serif text-4xl leading-tight text-ink">Our office</h2>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 flex flex-col gap-8">
                <div>
                  <p className="text-[10px] font-medium uppercase tracking-[0.25em] text-ink/45">Address</p>
                  <p className="mt-2 text-base leading-relaxed text-ink/85">
                    ARA Turnkey Projects Pvt. Ltd.<br />
                    Flat No 11, Dwarka, Tagore Road, Santacruz (West),<br />
                    Mumbai – 400054, Maharashtra, India
                  </p>
                </div>
                <div>
                  <p className="text-[10px] font-medium uppercase tracking-[0.25em] text-ink/45">Email</p>
                  <a
                    href="mailto:hello@araturnkey.com"
                    data-testid="about-email-link"
                    className="mt-2 inline-block border-b border-ink/30 pb-0.5 text-base text-ink transition-colors duration-300 hover:border-maroon hover:text-maroon"
                  >
                    hello@araturnkey.com
                  </a>
                </div>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <div className="overflow-hidden border border-ink/15" data-testid="about-map">
                <iframe
                  title="ARA Turnkey Projects · office location"
                  src="https://maps.google.com/maps?q=Tagore%20Road%2C%20Santacruz%20West%2C%20Mumbai%20400054&z=15&output=embed"
                  className="h-[380px] w-full lg:h-[440px]"
                  style={{ filter: "grayscale(1) contrast(1.05)" }}
                  loading="lazy"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
}
